import axios from 'src/admin-axios';
import Constants from 'src/constants';

export const digiboards = {
    namespaced: true,
    state: {
        digiBoardsList: [],
        createdDigiBoard: {},
        editDigiBoardContent: {},
        digiBoardLicenceContent: {},
        DigiBoardSettings: {},
    },
    getters: {
        getDigiBoardsList (state) {
            return state.digiBoardsList;
        },
        getCreatedDigiBoard (state) {
            return state.createdDigiBoard;
        },
        getDigiBoardContent (state) {
            return state.editDigiBoardContent;
        },
        getDigiBoardLicenceContent (state) {
            return state.digiBoardLicenceContent;
        },
        getDigiBoardSettings (state) {
            return state.DigiBoardSettings;
        },
    },
    mutations: {
        setDigiBoardsList (state, data) {
            state.digiBoardsList = data;
        },
        setCreatedDigiBoard (state, data) {
            state.createdDigiBoard = data;
        },
        clearCreatedDigiBoards (state) {
            state.createdDigiBoard = {};
        },
        setDigiBoardContent (state, data) {
            state.editDigiBoardContent = data;
        },
        setDigiBoardLicenceContent (state, data) {
            state.digiBoardLicenceContent = data;
        },
        setDigiBoardSettingsDetails (state, data) {
            state.DigiBoardSettings = data;
        },
    },
    actions: {
        async fetchDigiBoardsList ({ dispatch, commit }) {
            const url = '/digi-boards';
            try {
                const response = await axios.get(url);
                commit('setDigiBoardsList', response.data);
            } catch (exception) {
                dispatch('alert/onAlert', {
                    message: 'Something went wrong in getting the digi-boards list.',
                    type: Constants.ALERT_TYPE_ERROR,
                }, { root: true });
            }
        },
        async fetchDigiBoardsUnderOrganization ({ dispatch, commit }, { params }) {
            const url = '/digi-boards';
            try {
                const response = await axios.get(url, { params: params });
                commit('setDigiBoardsList', response.data);
            } catch (exception) {
                dispatch('alert/onAlert', {
                    message: 'Something went wrong in getting the digi-boards under this organization.',
                    type: Constants.ALERT_TYPE_ERROR,
                }, { root: true });
            }
        },
        async createDigiBoard ({ dispatch, commit }, payload) {
            const url = '/digi-boards';
            try {
                const response = await axios.post(url, payload);
                commit('setCreatedDigiBoard', response.data);
            } catch (exception) {
                dispatch('alert/onAlert', {
                    message: 'Something went wrong in creating the digi-board.',
                    type: Constants.ALERT_TYPE_ERROR,
                }, { root: true });
            }
        },
        async createDigiBoardLicence ({ dispatch }, payload) {
            const url = '/digi-boards/licence';
            try {
                 await axios.post(url, payload);
            } catch (exception) {
                dispatch('alert/onAlert', {
                    message: 'Something went wrong in creating your digi-board licence.',
                    type: Constants.ALERT_TYPE_ERROR,
                }, { root: true });
                throw exception;
            }
        },
        clearCreatedDigiBoard ({ commit }) {
            commit('clearCreatedDigiBoards');
        },
        async fetchDigiBoardContent ({ dispatch, commit }, { params }) {
            const url = '/digi-boards';
            try {
                const response = await axios.get(url, { params: params });
                const result = response.data[0] === undefined ? {} : response.data[0];
                commit('setDigiBoardContent', result);
            } catch (exception) {
                dispatch('alert/onAlert', {
                    message: 'Something went wrong in getting the digi-boards content.',
                    type: Constants.ALERT_TYPE_ERROR,
                }, { root: true });
            }
        },
        async fetchDigiBoardLicenceContent ({ dispatch, commit }, { params }) {
            const url = '/digi-boards/licence';
            try {
                const response = await axios.get(url, { params: params });
                const result = response.data[0] === undefined ? {} : response.data[0];
                commit('setDigiBoardLicenceContent', result);
            } catch (exception) {
                dispatch('alert/onAlert', {
                    message: 'Something went wrong in getting the digi-board Licence content.',
                    type: Constants.ALERT_TYPE_ERROR,
                }, { root: true });
                throw exception;
            }
        },
        async deleteLicence ({ dispatch }, licenceId) {
            const url = `/digi-boards/licence/cancel/${licenceId}`;
            try {
                await axios.post(url);
            } catch (exception) {
                dispatch('alert/onAlert', {
                    message: 'Something went wrong in deleting the Licence.',
                    type: Constants.ALERT_TYPE_ERROR,
                }, { root: true });
                throw exception;
            }
        },
         async fetchDigiBoardSettingsDetails ({ dispatch, commit, state }, payload) {
            const url = `${payload}/settings`;
            try {
                const details = await axios.get(url);
                commit('setDigiBoardSettingsDetails', details.data);
            } catch (exception) {
                dispatch('alert/onAlert', {
                    message: 'Something went wrong in getting the digi-board settings details.',
                    type: Constants.ALERT_TYPE_ERROR,
                }, { root: true });
                throw exception;
            }
        },
         async  createDigiBoardSettingsDetails ({ dispatch }, payload) {
            const url = `${payload.digiBoardId}/settings`;
            try {
                await axios.post(url, payload.settings);
            } catch (exception) {
                dispatch('alert/onAlert', {
                    message: 'Something went wrong in creating the digi-board settings.',
                    type: Constants.ALERT_TYPE_ERROR,
                }, { root: true });
                throw exception;
            }
        },
        async  updateDigiBoardSettingsDetails ({ dispatch }, payload) {
            const url = `${payload.digiBoardId}/settings/${payload.settingsId}`;
            try {
                await axios.put(url, payload.settings);
            } catch (exception) {
                dispatch('alert/onAlert', {
                    message: 'Something went wrong in updating the digi-board settings.',
                    type: Constants.ALERT_TYPE_ERROR,
                }, { root: true });
                throw exception;
            }
        },
    },
};
